export const formatDate = (date: string): string => {
  const [m, d, y] = date.split('/');
  return `${y}-${m}-${d}`;
};

export const recoverDate = (date: string): string => {
  const [y, m, d] = date.split('-');
  return `${m}/${d}/${y}`;
};
